import {useMemo} from "react";

export function RenderDescription(props: { description: string }) {
	return useMemo(() => {
		if(!props.description) return null;
		const chunks = props.description.split('\n');
		return chunks.map((c, i) => {
			if (!c) return <br key={i}/>;
			return <p key={i}>{c}</p>;
		});
	}, [props.description]);
}
